export default __webpack_public_path__ + "static/media/originalIdentityCard.11abe681.svg";